import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { DocumentsDashboardScreen } from '../../screens/tasks/documentManagement/DocumentsDashboardScreen';
import { DocumentsIntroScreen } from '../../screens/tasks/documentManagement/DocumentsIntroScreen';
import { DocumentsInputScreen } from '../../screens/tasks/documentManagement/DocumentsInputScreen';
import { DocumentsDataScreen } from '../../screens/tasks/documentManagement/DocumentsDataScreen';

const Stack = createNativeStackNavigator();

const DocumentsStackNavigator = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen name="DocumentsDashboardScreen" component={DocumentsDashboardScreen} />
    <Stack.Screen name="DocumentsIntroScreen" component={DocumentsIntroScreen} />
    <Stack.Screen name="DocumentsInputScreen" component={DocumentsInputScreen} />
    <Stack.Screen name="DocumentsDataScreen" component={DocumentsDataScreen} />
  </Stack.Navigator>
);

export default DocumentsStackNavigator;
